import React from "react";
import {
  Text,
  View,
  Linking,
  TouchableOpacity,
  Platform,
  SafeAreaView,
  Dimensions,
  ScrollView,
} from "react-native";
import { useTheme } from "./ThemeContext";

const { width: screenWidth } = Dimensions.get("window");
const isSmallScreen = screenWidth < 375; // iPhone SE, iPhone 13 mini
const scaleFactor = isSmallScreen ? 0.85 : 1.0;

export default function Contact() {
  const { themeValues } = useTheme();

  return (
    <SafeAreaView
      style={{
        flex: 1,
        backgroundColor: themeValues.background,
      }}
    >
      <ScrollView
        style={{
          flex: 1,
          backgroundColor: themeValues.background,
        }}
        contentContainerStyle={{
          padding: 20 * scaleFactor,
          paddingTop: Platform.OS === "ios" ? 100 : 90,
        }}
      >
        <View
          style={{
            transform: [{ scale: scaleFactor }],
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text
            style={{
              color: themeValues.primary,
              fontSize: 48 * scaleFactor,
              fontWeight: "bold",
              textAlign: "center",
              marginBottom: 50 * scaleFactor,
            }}
          >
            Contact Us
          </Text>

        <Text
          style={{
            color: themeValues.text,
            fontSize: 22,
            textAlign: "center",
            marginBottom: 35 * scaleFactor,
            lineHeight: 26,
          }}
        >
          Let us know how you like the app - email us at{"\n"}
          meditrateapp@gmail.com
        </Text>

        <TouchableOpacity
          style={{
            backgroundColor: `${themeValues.primary}20`,
            paddingVertical: 12,
            paddingHorizontal: 20,
            borderRadius: 8,
            marginBottom: 75 * scaleFactor,
            borderWidth: 1,
            borderColor: themeValues.primary,
          }}
          onPress={() => Linking.openURL("mailto:meditrateapp@gmail.com")}
        >
          <Text
            style={{
              color: themeValues.primary,
              fontSize: Platform.OS === "web" ? 22 : 18 * scaleFactor,
              textAlign: "center",
              fontWeight: "600",
            }}
          >
            Email:{Platform.OS === "ios" ? "\n" : " "}meditrateapp@gmail.com
          </Text>
        </TouchableOpacity>

        <Text
          style={{
            color: themeValues.text,
            fontSize: 22,
            textAlign: "center",
            marginBottom: 35,
            lineHeight: 26,
          }}
        >
          Visit our YouTube channel for popular meditation settings and tips.
          Like, subscribe and leave us a comment!
        </Text>

        <TouchableOpacity
          style={{
            backgroundColor: `${themeValues.primary}20`,
            paddingVertical: 12,
            paddingHorizontal: 20,
            borderRadius: 8,
            borderWidth: 1,
            borderColor: themeValues.primary,
          }}
          onPress={() => Linking.openURL("https://www.youtube.com/@MeditRate")}
        >
          <Text
            style={{
              color: themeValues.primary,
              fontSize: 22,
              textAlign: "center",
              fontWeight: "600",
            }}
          >
            YouTube: @MeditRate
          </Text>
        </TouchableOpacity>

        <Text
          style={{
            color: themeValues.text,
            fontSize: 22,
            textAlign: "center",
            marginTop: 35,
            marginBottom: 35,
            lineHeight: 26,
          }}
        >
          Download the iOS app from the App Store
        </Text>

        <TouchableOpacity
          style={{
            backgroundColor: `${themeValues.primary}20`,
            paddingVertical: 12,
            paddingHorizontal: 20,
            borderRadius: 8,
            borderWidth: 1,
            borderColor: themeValues.primary,
          }}
          onPress={() => Linking.openURL("https://apps.apple.com/us/app/meditrate/id6759229009")}
        >
          <Text
            style={{
              color: themeValues.primary,
              fontSize: 22,
              textAlign: "center",
              fontWeight: "600",
            }}
          >
            App Store: MeditRate
          </Text>
        </TouchableOpacity>

        <View style={{ marginTop: 100 }}>
          <Text
            style={{
              color: themeValues.muted,
              fontSize: 12,
              textAlign: "center",
            }}
          >
            © {new Date().getFullYear()} MeditRate. All rights reserved.
          </Text>
        </View>
      </View>
      </ScrollView>
    </SafeAreaView>
  );
}
